import { METHODOLOGY_STEPS } from '../data/content';
import { HelpCircle, TrendingUp, Layers, Zap, PieChart, Sparkles } from 'lucide-react';

export default function MetodologiaSection() {
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'HelpCircle':
        return <HelpCircle className="w-5 h-5 text-cyan-400" />;
      case 'TrendingUp':
        return <TrendingUp className="w-5 h-5 text-emerald-400" />;
      case 'Layers':
        return <Layers className="w-5 h-5 text-pink-400" />;
      case 'Zap':
        return <Zap className="w-5 h-5 text-purple-400" />;
      case 'PieChart':
        return <PieChart className="w-5 h-5 text-teal-400" />;
      default:
        return <Sparkles className="w-5 h-5 text-cyan-400" />;
    }
  };

  return (
    <section id="metodologia" className="py-20 md:py-28 bg-[#181126] text-white relative overflow-hidden">
      {/* Subtle grid background */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:3rem_3rem] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-left max-w-3xl space-y-3">
          <p className="text-xs font-bold text-pink-400 tracking-widest uppercase">METODOLOGÍA</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight leading-tight">
            Nuestro proceso en seis <br className="hidden sm:inline" />
            pasos
          </h2>
          <p className="text-sm sm:text-base text-slate-300 leading-relaxed">
            Un método probado que garantiza consistencia, foco y resultados medibles en cada proyecto.
          </p>
        </div>

        {/* 6 Steps Grid */}
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {METHODOLOGY_STEPS.map((step) => (
            <div
              key={step.number}
              className="p-6 rounded-2xl bg-slate-900/90 border border-slate-800 flex flex-col justify-between hover:border-cyan-500/40 transition-colors"
            >
              <div>
                <div className="flex items-center justify-between">
                  <div className="p-2.5 rounded-xl bg-slate-800/80 border border-slate-700/60">
                    {getIcon(step.icon)}
                  </div>
                  <span className="text-2xl font-black text-slate-500 tracking-wider">{step.number}</span>
                </div>

                <h3 className="mt-6 text-xl font-extrabold text-white">{step.title}</h3>
                <p className="mt-2 text-xs sm:text-sm text-slate-300 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
